import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MeetingBodies } from '../enums/meetingbodies';
import { EnvironmentLoader } from '../../../environments/utils/environment-loader.util';
import { EAG_Committee } from '../../interfaces/IMeetingsGmeetsColours';

@Injectable({
    providedIn: 'root'
})
export class EDELGATECalendarService {

    public headers: HttpHeaders;

    constructor(
        private http: HttpClient,
    ) {
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    }

    getAllAgendaItemsAndColors(AG_Committee: string) {
        return this.http.get(`${EnvironmentLoader.environment.igovAuthEndpoint}/e-delegate/integration/public/api/meetings-gmeets-colours/get-all`, {
            headers: this.headers,
            params: { AG_Committee: this.getBody(AG_Committee) }
        });
    }

    getAllMeetingByDate(body) {
        return this.http.post(`${EnvironmentLoader.environment.igovAuthEndpoint}/e-delegate/integration/public/api/gmeet/${body}`, {
            isCancelled: { $ne: true },
            removeHiddenMeetings: true
        }, {
            headers: this.headers,
        });
    }
    getBody(body: string) {
        switch (body) {
            case MeetingBodies.C1:
                return EAG_Committee.firstCommittee;
            case MeetingBodies.C3:
                return EAG_Committee.thirdCommittee;
            case MeetingBodies.C2:
                return EAG_Committee.secondCommittee;
            case MeetingBodies.C4:
                return EAG_Committee.fourthCommittee;
            case MeetingBodies.PLENARY:
                return MeetingBodies.PLENARY.toString();
            default:
                return null;
        }
    }
}
